export const LEGAL_UPDATE_REPORT_MODES = {
  complianceDeadline: {
    value: 'complianceDeadline',
    title: 'Legal Updates',
    short: 'Legal Updates',
    helper: 'Circulars and notifications, with the last date to comply.',
    dateLabel: 'Last date to comply',
  },
  trackerDueDate: {
    value: 'trackerDueDate',
    title: 'Assigned Tasks',
    short: 'Assigned Tasks',
    helper: 'Work created from those updates, with each task due date.',
    dateLabel: 'Task due date',
  },
};

export const reportModeLabel = (mode, key = 'title') =>
  LEGAL_UPDATE_REPORT_MODES[mode]?.[key]
  || LEGAL_UPDATE_REPORT_MODES.complianceDeadline[key];
